import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { getAdmin, getToken } from "./auth";
import Layout from "./components/Layout";
import { Page } from "./components/ui";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Members from "./pages/Members";
import MemberDetail from "./pages/MemberDetail";
import MemberActivity from "./pages/MemberActivity";
import Packages from "./pages/Packages";
import Deposits, { DepositDetail } from "./pages/Deposits";
import Currencies from "./pages/Currencies";
import Bep20Deposits from "./pages/Bep20Deposits";
import Bep20Sweep from "./pages/Bep20Sweep";
import PayoutWallet from "./pages/PayoutWallet";
import Withdrawals, { WithdrawalDetail } from "./pages/Withdrawals";
import Purchases, { PurchaseDetail } from "./pages/Purchases";
import Transfers, { TransferDetail } from "./pages/Transfers";
import Earnings from "./pages/Earnings";
import RoiFailures from "./pages/RoiFailures";
import Rewards from "./pages/Rewards";
import RewardClaims from "./pages/RewardClaims";
import Tickets from "./pages/Tickets";
import Content from "./pages/Content";
import Settings from "./pages/Settings";
import Staff from "./pages/Staff";
import Contacts from "./pages/Contacts";

function Private({ children }) {
  if (!getToken()) return <Navigate to="/admin/login" replace />;
  return children;
}

function SuperOnly({ children }) {
  const admin = getAdmin();
  if (!admin || admin.role !== "super_admin") {
    return (
      <Page title="Staff">
        <div className="alert">This page is only available to a super admin.</div>
      </Page>
    );
  }
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin/login" element={<Login />} />
        <Route path="/admin" element={<Private><Layout /></Private>}>
          <Route index element={<Dashboard />} />
          <Route path="members" element={<Members />} />
          <Route path="members/:id/activity" element={<MemberActivity />} />
          <Route path="members/:id" element={<MemberDetail />} />
          <Route path="packages" element={<Packages />} />
          <Route path="deposits" element={<Deposits />} />
          <Route path="deposits/:id" element={<DepositDetail />} />
          <Route path="currencies" element={<Currencies />} />
          <Route path="bep20-deposits" element={<Bep20Deposits />} />
          <Route path="bep20-sweep" element={<Bep20Sweep />} />
          <Route path="payout-wallet" element={<PayoutWallet />} />
          <Route path="withdrawals" element={<Withdrawals />} />
          <Route path="withdrawals/:id" element={<WithdrawalDetail />} />
          <Route path="purchases" element={<Purchases />} />
          <Route path="purchases/:id" element={<PurchaseDetail />} />
          <Route path="transfers" element={<Transfers />} />
          <Route path="transfers/:id" element={<TransferDetail />} />
          <Route path="earnings" element={<Earnings />} />
          <Route path="roi-failures" element={<RoiFailures />} />
          <Route path="rewards" element={<Rewards />} />
          <Route path="reward-claims" element={<RewardClaims />} />
          <Route path="tickets" element={<Tickets />} />
          <Route path="tickets/:id" element={<Tickets />} />
          <Route path="content" element={<Content />} />
          <Route path="settings" element={<Settings />} />
          <Route path="staff" element={<SuperOnly><Staff /></SuperOnly>} />
          <Route path="contacts" element={<Contacts />} />
        </Route>
        <Route path="/" element={<Navigate to="/admin" replace />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
